"use client";

import ButtonNF from '@/app/ui/forms/ButtonNF';
import BlurFade from '@/app/ui/magicui/blur-fade';
import { cn, UsefulLinksIcon } from '@/lib/utils';
import { QnA } from '@prisma/client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function QnaListComponent({ qnaList }: { qnaList: QnA[] }) {
    const path = usePathname();
    const id = path.split("/").pop();

    return (
        <nav className='container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-around my-4'>
            { qnaList.map((qna, index) => {
                const selected = id == qna.id.toString();
                const Icon = UsefulLinksIcon(qna.icon)
                return <BlurFade key={ qna.id } delay={ index * 0.2 }
                    className={ cn('flex-1 border-2  rounded-2xl p-3 flex bg-slate-800 shadow-lg shadow-black/50',
                        selected && "border-yellow-400 hover:border-yellow-300"
                    ) }
                >
                    <article className='flex flex-col md:flex-row gap-5 w-full items-stretch group'>
                        { Icon && <Icon size={ "6rem" } className={ cn("self-center text-nfBlue-300", selected && "text-yellow-400") } /> }
                        <div className='flex flex-col gap-5 flex-1 justify-between text-center'>
                            <h4 role="heading" className='leading-[0.9] text-clip'>{ qna.q }</h4>
                            <Link href={ `/qna/${qna.id}` }>
                                <ButtonNF className='rounded-full text-2xl w-full' color={ selected && "gray" || "nfBlue" } disabled={ selected }>
                                    עבור לתשובה
                                </ButtonNF>
                            </Link>
                        </div>
                    </article>
                </BlurFade>
            }) }
        </nav>
    )
}